import { render } from "./ContactSectionComponent.vue?vue&type=template&id=6f899026&ts=true"
import script from "./ContactSectionComponent.vue?vue&type=script&lang=ts"
export * from "./ContactSectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__